/**
 * Checks that each list has the same length and contains the same values, in any order.
 * Only checks referential equality.
 */
export const doListsContainSameElements = <T>(list1: T[], list2: T[]) =>
  list1.length === list2.length && list1.every(item => list2.includes(item));
